import { useAuth } from '../../auth/authContext'
import { useProfile } from './useProfile'

/** Protected landing screen: shows token claims + live BFF asset data. */
export function ProfilePage() {
  const { claims } = useAuth()
  const { data, isLoading, error } = useProfile()

  return (
    <div className="p-6 space-y-4">
      <h1 className="text-lg font-bold">Profile</h1>

      <section className="space-y-1">
        <h2 className="text-sm font-semibold text-gray-700">From token claims</h2>
        <p className="text-sm text-gray-600">Email: {claims?.email ?? '—'}</p>
        <p className="text-sm text-gray-600">Asset ID: {claims?.assetId ?? '—'}</p>
      </section>

      <section className="space-y-1">
        <h2 className="text-sm font-semibold text-gray-700">From BFF /me/asset-data</h2>
        {isLoading && <p className="text-sm text-gray-600">Loading…</p>}
        {error && <p className="text-sm text-red-600">{(error as Error).message}</p>}
        {data && (
          <pre className="overflow-auto rounded bg-gray-100 p-3 text-xs">
            {JSON.stringify(data, null, 2)}
          </pre>
        )}
      </section>
    </div>
  )
}
